var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.poem)?_c('div',{staticClass:"sb_poem-preview"},[(_vm.name)?_c('span',[_vm._v("Lieve "+_vm._s(_vm.name)+", "),_c('br'),_vm._v("   "),_c('br')]):_vm._e(),_vm._v(" "+_vm._s(_vm.poem)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }